import useSWR from 'swr'
import { useRouter } from 'next/router'
import { defaultState, UserProfileResponse } from '../fetchProfile'
import { PlayerUserDataContext } from '../../contexts/PlayerUserDataContext'
import { useContext, useEffect, useState } from 'react'

function useProfile(hostUrl = '', cloudinaryEnv = '') {

  const router = useRouter()
  const preAuth = router.query['player-preauth'] as string ?? ''
  const { userVerified } = useContext(PlayerUserDataContext)
  const [sessionSuccessful, setSessionSuccessful] = useState(false)

  const swr = useSWR<UserProfileResponse>(['user', hostUrl, cloudinaryEnv], {
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {

      if (error.status === 404) return

      // Retry every five minutes on failure
      setTimeout(() => revalidate({ retryCount: retryCount + 1 }), 60000 * 5)

    },
    onSuccess: data => {

      data['preAuth'] = preAuth
      data['sessionSuccessful'] = true
      setSessionSuccessful(true)

    },
    onError: data => {

      data['preAuth'] = preAuth
      data['sessionSuccessful'] = false
      setSessionSuccessful(false)

    },
    revalidateOnMount: false,
    revalidateOnFocus: false,
    initialData: {
      ...defaultState,
      isLoggedIn: false,
      sessionSuccessful,
      preAuth
    }
  })

  useEffect(() => {

    if (!swr?.data?.isLoggedIn && userVerified || (swr?.data?.isLoggedIn && swr.data.id === '')) {

      swr.revalidate()

    }

  }, [swr, userVerified])

  return swr

}

export default useProfile
